import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAppSelector } from "~/hooks/appSelector";
import { TemplateRequest } from "~/models/Commons ";
import { useGetCloudEnvironmentsQuery } from "~/services/cloudenvironment";
import { useGetProvidersQuery } from "~/services/providers";
import { useGetComponentsQuery } from "~/services/vm/Components";
import { useSaveVmTemplatesMutation, useUpdateVmTemplatesMutation } from "~/services/vm/VmTemplate";
import { selectProvider } from "~/store/feature/Provider";
import { getDefaultQueryParams } from "~/Utils/Utils";

export const UseVmTemplateForm = (
  onCloseModal: () => void,
  refetch: () => void,
  templateId:number
) => {
   const { data:providerData } = useGetProvidersQuery();
  const [saveVmTemplates] = useSaveVmTemplatesMutation();
  const [updateVmTemplates] = useUpdateVmTemplatesMutation();
  const { cloudProviderName } = useAppSelector(selectProvider);
  const { data: cloudEnvData } = useGetCloudEnvironmentsQuery({
    page: 0,
    size: 100,
    active: true,
  });



  const { data: ConfigurationComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("vmConfiguration")
  );

  const { data: ProvissioningComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("postProvisioning")
  );

  const { data: PolicyComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("policy")
  );

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    resetField
  } = useForm<TemplateRequest>({
    defaultValues: {
      cloudEnvironmentId: undefined,
      cloudProvisionerTemplateId:undefined,
      name: "",
      cpuCore: undefined,
      ram: undefined,
      storage: undefined,
      vmconfiguration: "",
      vmPostProviosiing: "",
      vmPolicy: "",
      components: undefined,
      os: "",
      description: "",
      azureVmSize: undefined,
      awsInstanceType: undefined,
    },
  });


  const submitForm = async (data: TemplateRequest) => {
    try {
      const components: number[] = [
        data.vmconfiguration?.value ?? data.vmconfiguration,
        data.vmPostProviosiing?.value ?? data.vmPostProviosiing,
        data.vmPolicy?.value ?? data.vmPolicy,
      ].filter(Boolean) as number[];

      const payload: TemplateRequest = {
        ...data,
        components,
        cloudEnvironmentId: data.cloudEnvironmentId?.value,
        cloudProvisionerTemplateId: data.cloudProvisionerTemplateId?.value,
        os: data.os.value,
        azureVmSize: (data.azureVmSize as any)?.value ?? data.azureVmSize,
        awsInstanceType: (data.awsInstanceType as any)?.value ?? data.awsInstanceType,
      };

      const response = await saveVmTemplates(payload).unwrap();

      if (response?.success) {
        toast.success(response?.message ?? "Template saved successfully");
      } else {
        throw new Error("Save operation failed: No success flag in response");
      }
    } catch (error: any) {
      const errorTitle = error?.data?.title ?? error?.title ?? "Unknown error";
      const errorStatus = error?.data?.status ?? error?.status ?? "N/A";

      toast.error(`Status: ${errorStatus}\nTitle: ${errorTitle}`);
      console.error("submitForm: error occurred", error);
    } finally {
      refetch();
      onCloseModal();
    }
  };
const updateForm = async (_data: TemplateRequest) => {
  try {
    const components: number[] = [
      _data.vmconfiguration?.value ?? _data.vmconfiguration,
      _data.vmPostProviosiing?.value ?? _data.vmPostProviosiing,
      _data.vmPolicy?.value ?? _data.vmPolicy,
    ].filter(Boolean) as number[];

    const payload: TemplateRequest = {
      ..._data,
      id: _data.id,
      components,
      cloudEnvironmentId: _data.cloudEnvironmentId?.value ?? _data.cloudEnvironmentId,
      cloudProvisionerTemplateId: _data.cloudProvisionerTemplateId?.value ?? _data.cloudProvisionerTemplateId,
      os: _data.os?.value ?? _data.os,
      azureVmSize: (_data.azureVmSize as any)?.value ?? _data.azureVmSize,
      awsInstanceType: (_data.awsInstanceType as any)?.value ?? _data.awsInstanceType,
    };

    const response = await updateVmTemplates({
      id: templateId,
      data: payload,
    }).unwrap();

    if (response.success) {
      toast.success(response?.message);
    } else {
      throw new Error('Save operation failed: No success response');
    }
  } catch (error: any) {
    const errorTitle =
      error?.data?.title || error?.title || 'Error Updating VM Template';
    const errorStatus =
      error?.data?.status || error?.status || 'Unknown Status';
    toast.error(`Code: ${errorStatus}\nTitle: ${errorTitle}`);
    console.error('Error updating VM template:', error);
  } finally {
    refetch();
    onCloseModal();
    console.log('updateForm: completed');
  }
};

  return {
    handleSubmit,
    control,
    errors,
    cloudProviderName,
    cloudEnvData,
    ConfigurationComponentsData,
    ProvissioningComponentsData,
    PolicyComponentsData,
    providerData,
    submitForm,
    updateForm,
    reset,
    setValue,
    watch,
    resetField,
    templateId
  };
};
